import {
  MatchRuleEntity,
  useFindManyMatchRulesQuery,
} from 'src/store/matchRuleApi';
import { useEffect, useRef, useState } from 'react';
import { useFindManyInterviewsQuery } from 'src/store/interviewApi';
import { useDispatch } from 'react-redux';
import { setInterviews } from 'src/store/interviewSlice';
import { setMatchRules } from 'src/store/matchRuleSlice';
import Outline from './outline';
import Editor, { EditorRef } from './editor';
import Content, { ContentRef } from './content';
import TestRule, { TestRuleRef } from './testRule';

const MatchRules = () => {
  const { data: interviewData } = useFindManyInterviewsQuery();
  const { data: matchRuleData, refetch } = useFindManyMatchRulesQuery();
  const dispatch = useDispatch();
  const [selectedMatchRule, setSelectedMatchRule] = useState<number>(0);
  const editorRef = useRef<EditorRef>(null);
  const contentRef = useRef<ContentRef>(null);
  const testRuleRef = useRef<TestRuleRef>(null);

  useEffect(() => {
    if (!interviewData?.data) return;
    dispatch(setInterviews(interviewData.data));
  }, [interviewData, dispatch]);

  useEffect(() => {
    if (!matchRuleData?.data) return;
    dispatch(setMatchRules(matchRuleData.data));
  }, [matchRuleData, dispatch]);

  const onSelectMatchRule = (matchRule: MatchRuleEntity, scroll = false) => {
    setSelectedMatchRule(matchRule.id);
    editorRef.current?.onSelect(matchRule);
    if (scroll) {
      contentRef.current?.scrollTo(matchRule.id);
    }
  };

  const onAddNew = () => {
    editorRef.current?.onCreate();
  };

  const onTestMatchRule = () => {
    testRuleRef.current?.onTestRule(selectedMatchRule);
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '280px 1fr 480px 480px',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Outline onAddNew={onAddNew} setSelectedMatchRule={onSelectMatchRule} />
      <Content ref={contentRef} setSelectedMatchRule={onSelectMatchRule} />
      <Editor
        ref={editorRef}
        refetchAll={refetch}
        onTestMatchRule={onTestMatchRule}
      />
      <TestRule ref={testRuleRef} />
    </div>
  );
};

export default MatchRules;
